import { NavigationItems } from './NavigationItems';

export function Navigation() {
  return (
    <nav className="header_navigation hidden lg:flex flex-1 justify-center items-center gap-4 p-2">
      <NavigationItems className="font-bold" />
    </nav>
  );
}
